import SourceData from './SourceData';

class SourceRenderer {
  constructor ($elm) {
    this.$elm = $elm;
  }

  render () {
    const { $elm } = this;

    let result = '';
    $elm.each((idx, elm) => {
      result += this.renderElement(elm);
    });

    return result;
  }

  renderElement (elm) {
    const data = new SourceData(elm);

    if (!data.canRender()) {
      return data.getRawSource();
    }

    return `<div contentEditable="false" data-ke-type="source" data-source="${data.getSource()}">
      <div class="source-title">${data.getTitle()}</div>
      <div class="source-content">
        <div class="source-content-inner">${data.getContent()}</div>
      </div>
    </div>`;
  }
}

export default SourceRenderer;
